import styled, { css } from "styled-components";

export const ComponentWrapper = styled.div`
  padding-bottom: 90px;
`;

export const CardWrapper = styled.div`
  margin-top: 29px;

  ${({ theme }) => css`
    .months-columns__card-fluxo-modalidade {
      display: flex;
    }

    .months-wrapper {
      width: 100%;
      padding: 3px;
      display: flex;
      overflow-x: scroll;
      white-space: nowrap;
    }
  `}
`;

export const Div = styled.div`
  margin-top: 5px;

  ${({ theme }) => css`
    .title {
      display: inline-block;
      font-size: 12px;
      font-family: Roboto;
      color: #747576;
      margin-right: 8px;
      margin-left: 8px;
    }
    p {
      display: inline-block;
      font-size: 9px;
      font-family: Roboto;
      color: #747576;
    }

    .input {
      display: inline-block;
      width: 100px;
    }

    .input_resumo {
      display: inline-block;
      width: 100px;
      margin-left: 48px;
    }
  `}
`;

export const Label = styled.div`
  font-size: 12px;
  font-family: Roboto;
  text-align: left;
  width: 100%;
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-bottom: 10px;
`;

export const LabelBold = styled.div`
  font-size: 12px;
  font-family: Roboto;
  text-align: left;
  width: 100%;
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-bottom: 10px;
  font-weight: bold;
`;

export const InternalTitle = styled.div`
  font-size: 12px;
  font-family: Roboto;
  text-align: left;
  width: 100%;
  line-height: 14px;
  opacity: 0.9;
  color: #747576;
  margin-left: 3px;
  margin-bottom: 1rem;
`;

export const CardFilled = styled.div`
  padding: 21.3px 19.5px 31px 20px;
  border-radius: 6px;
  background-color: #f6f6f6;
`;

export const Card = styled.div`
  padding: 21px 19px 15px 20px;
  border-radius: 6px;
  border: solid 1px #b9b9ba;

  ${({ theme }) => css`
    .border {
      border-right: solid 1px #b9b9ba;
    }
    .itens {
      margin: auto;
      width: 280px;
    }
  `}
`;

export const Separator = styled.div`
  height: 0;
  margin: 5px 1px 25px 1px;
  border-top: 1px solid #b9b9ba;
`;

export const Table = styled.table`
  ${({ theme }) => css`
    margin-top: -0.4rem;
    width: 100%;

    #modalidade-inner-table {
      background-color: white !important;

      white-space: normal;
      justify-content: start;
    }
    th {
      font-weight: normal;
      padding-bottom: 0.8rem;
      font-size: 12px;
      font-family: Roboto;
      color: #747576;
      text-align: center;
    }
    td {
      height: 9.5px;
      padding-bottom: 0.8rem;
      text-align: center;
      color: #000;
      border-radius: 6px;
      font-size: 11px;
      font-family: Roboto;
      font-weight: 500;
    }

    .itemEspecie {
      height: 9.5px;
      width: 1090px;
      padding-bottom: 0.8rem;
      text-align: center;
      color: #000;
      border-radius: 6px;
      font-size: 11px;
      font-family: Roboto;
      font-weight: 500;
      background-color: #f00909;
    }

    .itemVendedor {
      height: 9.5px;
      width: 1090px;
      padding-bottom: 0.8rem;
      text-align: center;
      color: #000;
      border-radius: 6px;
      font-size: 11px;
      font-family: Roboto;
      font-weight: 500;
      background-color: #f00909;
    }
    .title {
      font-size: 12px;
      font-family: Roboto;
      color: #747576;
      font-weight: normal;
    }
  `}
`;

export const CardOutrasPropostas = styled.div`
  ${({ theme }) => css`
    .height-modifier__card-outras-propostas {
      height: 3.5rem;
      font-size: 11px;
      line-height: 3.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }
    .wrapper-columns__card-outras-propostas {
      display: flex;
      padding: 3px;
    }
    .columns__card-outras-propostas {
      width: 100%;
      p {
        text-align: center;
        margin-right: 10%;
      }
    }

    .last-column__card-outras-propostas {
      p {
        text-align: center;
        margin-right: 10%;
        color: #747576;
      }
      width: 19%;
    }
  `}
`;

export const WrapperContent = styled.div`
  ${({ theme }) => css``}
  p {
    font-size: 12px;
    font-family: Roboto;
    color: #747576;
  }
`;

export const DivContent = styled.div`
  ${({ theme }) => css`
    margin-top: 1rem;
    width: 90%;
    height: 3rem;
    line-height: 3rem;
    border-radius: 5px;
    color: #000;
    border-radius: 10px;
    font-size: 11px;
    font-family: Roboto;
    font-weight: 500;
  `}
`;
